import { Badge } from "@/components/ui/badge";
import { cn } from "@/components/ui/utils";

/**
 * Name + outline code badge for non-dropdown UI (filter chips, tooltips, dialog copy).
 * For Select / ComboBox / Command rows, pair the name with `ItemDetail` from `@/components/ui/list-box`.
 */
export function TestSpecLabel({
  name,
  code,
  className,
  nameClassName,
}: {
  name: string;
  code: string;
  className?: string;
  nameClassName?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex min-w-0 max-w-full items-center gap-2",
        className,
      )}
    >
      <span className={cn("min-w-0 truncate", nameClassName)}>{name}</span>
      <Badge
        variant="outline"
        size="sm"
        className="shrink-0 font-mono tabular-nums font-normal"
      >
        {code}
      </Badge>
    </span>
  );
}
